module.exports = __webpack_public_path__ + "media/images/lb/823-74cff6fcc78679fe16a262a9f50ed086.svg";